import Select from "./core/selector";

const cookieName = "lang";

Select.byClassAll("lang-change").forEach((element) => {
  if (element.classList.contains("active")) {
    setCookie(getLanguageValueFromElement(element));
  }

  element.addEventListener("click", (event) => {
    event.preventDefault();
    const lang = getLanguageValueFromElement(element);
    if (lang) {
      setCookie(lang);

      const path = window.location.pathname;
      if (path.length == 1) {
        if (lang !== "en") {
          window.location.pathname = `/${lang}`;
        }
        return;
      }

      const pathParts = path.split("/");
      if (pathParts[1] === lang) {
        return;
      }

      pathParts[1] = lang;
      window.location.pathname = pathParts.join("/");
    }
  });
});

function getLanguageValueFromElement(element: HTMLElement): string {
  return element.getAttribute("data-lang-target") || "";
}

function setCookie(lang: string) {
  var currentLangCookie = getCookie();
  if (currentLangCookie === lang) {
    return;
  }

  document.cookie = `${cookieName}=${lang};path=/;max-age=31536000`;
}

function getCookie(): string | null {
  var cookieRow = document.cookie
    .split("; ")
    .find((row) => row.startsWith(cookieName));

  return cookieRow ? cookieRow.split("=")[1] : null;
}
